import React, {Component}   from 'react';
import PropTypes            from 'prop-types';
import FieldError           from '../Fragments/FieldError';

let Quote = require('../Managers/Quote.js');
let Validation = require('../Managers/Validation.js');

class ButtonChoice extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeValue: props.defaultValue ? props.defaultValue : null,
            hasError: false,
            isValid: false,
            showOtherActiveValues: false,
            isOtherActive: false,
        };
    }

    componentWillMount() {
        if (!window.uornorb(this.props.defaultValue)) {
            this.setState({
                isValid: true,
                activeValue: this.props.defaultValue,
                hasError: false,
            }, () => {
                this.props.isValid(true);
            });
        }

        // our default doesnt exist - dont pre-tick anything
        if (window.uornorb(this.props.defaultValue)) {
            return false;
        }

        // if its a string, make sure we're matching against uppercase
        let defaultValue = this.props.defaultValue;
        if (typeof defaultValue === 'string' || defaultValue instanceof String) {
            defaultValue = defaultValue.toUpperCase();
        }

        // make a list of the values and capitalise them if they're strings
        let standardOptions = this.props.options.map(option => {
            if (typeof option.value === 'string' || option.value instanceof String) {
                return option.value.toUpperCase();
            } else {
                return option.value;
            }
        });

        if (this.props.otherOptions && standardOptions.indexOf(defaultValue) === -1) {
            // if we support other options and our value isnt a standard option,
            // just show the stuff for the other option
            this.props.otherOptions.onOtherCallback();
            this.setState({ isOtherActive: true }, () => {
                this.props.isValid(true);
            });
        }

        if (this.props.onLoadFunction) {
            this.props.onLoadFunction(defaultValue);
        } else if (this.props.callbackFunction) {
            this.props.callbackFunction(defaultValue);
        }
    }

    setActiveValue(value) {
        // if we have other options, do the callback that occurs when
        // we select a "real", standard value
        if (this.props.otherOptions && this.props.otherOptions.offOtherCallback) {
            this.props.otherOptions.offOtherCallback();
            this.setState({ isOtherActive: false });
        }

        // if or key or value is undefined or null,
        // its not valid. otherwise it is
        if (window.uorn(value)) {
            this.setState({ isValid: false }, () => {
                this.props.isValid(false);
            });
        } else {
            this.setState(Object.assign({}, Validation.validObject(), { activeValue: value }), () => {
                this.props.isValid(true);
            });
        }

        // set our local storage value and call our general callback regardless
        Quote.set(this.props.storageKey, value, this.props.source);
        Quote.setAnswer(this.props.storageKey, value);

        if (this.props.callbackFunction) {
            this.props.callbackFunction(value);
        }
    }

    getCurrentValue() {
        return this.state.activeValue;
    }

    handleValidation(value) {
        // if this button has proper other options, AND the
        // other one is selected, then its valid by default...
        if (this.props.otherOptions && this.state.isOtherActive) {
            this.setState(Validation.validObject(), () => {
                this.props.isValid(true);
            });
            return true;
        }

        // if it has no data validation, by that nature it has to be valid
        if (window.uornorb(this.props.dataValidation)) {
            this.setState(Validation.validObject(), () => {
                this.props.isValid(true);
            });
        } else {
            // ...otherwise check validation and set the state up
            let validation = Validation.validate(this.props.dataValidation, value)[0];
            this.setState(validation, () => {
                this.props.isValid(validation.isValid);
            });
        }
    }

    render() {
        // todo: we now allow a renderOptionAs - this could be utilised to show actual radios or anything else we want, or just removed
        // We want to append a new className to button choices that have only
        // two options available so we don't stretch them out on tablets.
        let numberOfChoices = this.props.options.length;
        let wrapperClass = 'button-choices';
        if (numberOfChoices == 2) {
            wrapperClass = 'button-choices two';
        }
        return (
            <div className="question-input">
                <div className={wrapperClass}>
                    {this.props.options.map(function(choice, index) {
                        if (choice.type && choice.type === 'link') {
                            return (
                                <a
                                    key={index}
                                    onClick={this.setActiveValue.bind(this, choice.value)}
                                    id={this.props.fieldName + '_' + index}
                                    className="underline"
                                >
                                    {choice.text}
                                </a>
                            );
                        } else {
                            return (
                                <div
                                    key={index}
                                    onClick={this.setActiveValue.bind(this, choice.value)}
                                    value={choice.value}
                                    id={this.props.fieldName + '_' + index}
                                    className={!this.state.isOtherActive && this.state.activeValue === choice.value ? 'button-choice active' : 'button-choice'}>
                                    {choice.text}
                                </div>
                            );
                        }
                    }, this)}

                    {this.props.otherOptions ?
                        <div
                            onClick={() => {
                                // make sure the component is valid and known that
                                // the other option is selected
                                this.setState(Object.assign({}, Validation.validObject(), { isOtherActive: true }), () => {
                                    // we want there to be a tick,so pass true as a "fake"
                                    // second argument so that Field.js doesnt think we;re
                                    // non mandatory
                                    this.props.isValid(true, true);
                                });

                                // call the "you click the other button" callback
                                this.props.otherOptions.onOtherCallback();

                                // if we wanna clear the value on other, it probably
                                // means whatever is revealed by other uses the same
                                // storage key and source
                                if (this.props.otherOptions.clearValueOnOther) {
                                    Quote.set(this.props.storageKey, null, this.props.source);
                                    Quote.setAnswer(this.props.storageKey, null);
                                }
                            }}
                            className={this.state.isOtherActive ? 'button-choice active' : 'button-choice'}>
                            Other
                        </div>
                    : null }
                </div>

                {this.state.hasError === true ?
                    <FieldError errors={this.state.errors} />
                :null}

            </div>
        );
    }
}

ButtonChoice.propTypes = {
    question:           PropTypes.string.isRequired,
    fieldName:          PropTypes.string.isRequired,
    storageKey:         PropTypes.string,
    options:            PropTypes.array.isRequired,
    children:           PropTypes.array,
    callbackFunction:   PropTypes.func,
    source:             PropTypes.string,
    isValid:            PropTypes.func,
    dataValidation:     PropTypes.string,
    otherOptions:       PropTypes.object,
    onLoadFunction:     PropTypes.func,
    defaultValue:       PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.bool,
    ]),
};

export default ButtonChoice;


// WEBPACK FOOTER //
// ./src/components/Fields/ButtonChoiceInput.js